<template>

    <div class="px-6 py-4 bg-minplan-beige -mb-4">
        <page-title :title="$t('documents.edit')"></page-title>
    </div>

    <jet-form-section @submitted="updateDocument()">

        <template #form>

            <!-- Card Document Edit -->
            <form-card :title="$t('documents.document')" :description="$t('documents.documentDescription')">

                <div class="col-span-6">
                    <label for="name" class="block text-sm font-medium text-gray-700">{{
                            $t("documents.title")
                        }} <RequiredMark /></label>
                    <input type="text" name="name" id="name" v-model="form.name"
                           class="mt-1 focus:ring-minplan-blue focus:border-minplan-blue block w-full shadow-sm sm:text-sm border-gray-300"
                           autofocus />
                    <jet-input-error :message="form.errors.name" class="mt-2" />
                </div>

                <div class="col-span-6">
                    <label for="comment" class="block text-sm font-medium text-gray-700">{{
                            $t("documents.comment")
                        }}</label>
                    <div class="flex">
                        <textarea type="textarea" name="comment" id="comment" v-model="form.comment"
                                  class="mt-1 focus:ring-minplan-blue focus:border-minplan-blue block w-full shadow-sm sm:text-sm border-gray-300" />
                    </div>
                    <jet-input-error :message="form.errors.comment" class="mt-2" />
                </div>

            </form-card>

        </template>

        <template #actions>
            <div class="flex justify-end my-4 mx-6">

                <button @click="cancel" type="button" class="inline-block uppercase font-semibold text-xs tracking-widest">
                    {{ $t("actions.cancel") }}
                </button>

                <primary-button type="button" @click="updateDocument" :class="{ 'opacity-25': form.processing }" :disabled="form.processing" class="ml-3 ">
                    <span v-if="form.processing" class="flex items-center gap-1">
                        <svg class="animate-spin h-3 w-3 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
                        Saving...
                    </span>
                    <span v-else>{{ $t("actions.save") }}</span>
                </primary-button>

            </div>
        </template>

    </jet-form-section>

</template>


<script>
import { defineComponent, ref } from "vue";
import MainLayout from "@/Layouts/MainLayout";
import PrimaryButton from "@/Jetstream/PrimaryButton";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import JetFormSection from "@/Jetstream/FormSection";
import JetInput from "@/Jetstream/Input";
import JetInputError from "@/Jetstream/InputError";
import JetLabel from "@/Jetstream/Label";
import PageTitle from "@/Shared/Components/PageTitle";
import { useForm, usePage } from "@inertiajs/inertia-vue3";
import FormCard from "@/Shared/Components/FormCard";
import RequiredMark from "@/Shared/Components/RequiredMark";
import DigitalSignatureConfig from "@/Shared/Components/Documents/Modals/DigitalSignatureConfig.vue";
import axios from "axios";

export default defineComponent({
    props: ["document"],
    inheritAttrs: false,
    layout: MainLayout,
    emits: ["closeModal"],
    components: {
        PageTitle,
        PrimaryButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        FormCard,
        RequiredMark,
        DigitalSignatureConfig,
    },
    computed: {
    },
    methods: {
        cancel() {
            this.$emit("closeModal");
        },
        updateDocument() {
            this.form.post(this.document.updateLink, {
                preserveScroll: true,
                onSuccess: () => this.$notify({
                    group: "success",
                    title: "actions.success",
                    text: "documents.updated"
                })
            });
        },
    },
    setup(props) {
        const form = useForm({
            name: props.document.name,
            comment: props.document.comment,
            changedFile: false,
        });

        return { form };
    },
    props: ["document"],
});
</script>

<style scoped></style>
